/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { serviceDeliveryLocationRoleTypeIdGet } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-id-get';
import { ServiceDeliveryLocationRoleTypeIdGet$Params } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-id-get';
import { ServiceDeliveryLocationRoleTypeModel } from '../models/service-delivery-location-role-type-model';
import { ServiceDeliveryLocationRoleTypeModelSearchResultModel } from '../models/service-delivery-location-role-type-model-search-result-model';
import { serviceDeliveryLocationRoleTypePost } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-post';
import { ServiceDeliveryLocationRoleTypePost$Params } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-post';
import { serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-search-service-delivery-location-role-type-post';
import { ServiceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Params } from '../fn/service-delivery-location-role-type/service-delivery-location-role-type-search-service-delivery-location-role-type-post';

@Injectable({ providedIn: 'root' })
export class MDIServiceDeliveryLocationRoleTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost()` */
  static readonly ServiceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePostPath = '/ServiceDeliveryLocationRoleType/SearchServiceDeliveryLocationRoleType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Response(params?: ServiceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModelSearchResultModel>> {
    return serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost(params?: ServiceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Params, context?: HttpContext): Observable<ServiceDeliveryLocationRoleTypeModelSearchResultModel> {
    return this.serviceDeliveryLocationRoleTypeSearchServiceDeliveryLocationRoleTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModelSearchResultModel>): ServiceDeliveryLocationRoleTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `serviceDeliveryLocationRoleTypeIdGet()` */
  static readonly ServiceDeliveryLocationRoleTypeIdGetPath = '/ServiceDeliveryLocationRoleType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceDeliveryLocationRoleTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceDeliveryLocationRoleTypeIdGet$Response(params: ServiceDeliveryLocationRoleTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModel>> {
    return serviceDeliveryLocationRoleTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceDeliveryLocationRoleTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceDeliveryLocationRoleTypeIdGet(params: ServiceDeliveryLocationRoleTypeIdGet$Params, context?: HttpContext): Observable<ServiceDeliveryLocationRoleTypeModel> {
    return this.serviceDeliveryLocationRoleTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModel>): ServiceDeliveryLocationRoleTypeModel => r.body)
    );
  }

  /** Path part for operation `serviceDeliveryLocationRoleTypePost()` */
  static readonly ServiceDeliveryLocationRoleTypePostPath = '/ServiceDeliveryLocationRoleType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceDeliveryLocationRoleTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceDeliveryLocationRoleTypePost$Response(params?: ServiceDeliveryLocationRoleTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return serviceDeliveryLocationRoleTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceDeliveryLocationRoleTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceDeliveryLocationRoleTypePost(params?: ServiceDeliveryLocationRoleTypePost$Params, context?: HttpContext): Observable<string> {
    return this.serviceDeliveryLocationRoleTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
